module.exports = __webpack_public_path__ + "img/progress_034.9ecbaf19.png";